import z from 'zod';
import { ImageTs } from '../../common';



//advantage-card
export type AdvantageCard = z.output<typeof AdvantageCardSchema>;
export const AdvantageCardSchema = z.object({
  title: z.string(),
  content: z.string(),
  advantage1: z.string(),
  advantage2: z.string(),
  advantage3: z.string(),
  message: z.string(),
  cta: z.string(),
});


//engaging-card
export type EngaginCard = z.output<typeof EngaginCardSchema>;
export const EngaginCardSchema = z.object({
  title: z.string(),
  subtitle: z.string(),
  paragraph1: z.string(),
  paragraph2: z.string(),
  tagLine: z.string(),
  image: ImageTs
});

//hero
export type Hero = z.output<typeof HeroSchema>;
export const HeroSchema = z.object({
  tagLine: z.string(),
  content: z.string(),
  becomePartnerCta: z.string(),
  loginCta: z.string(),
  picture: ImageTs
});

//promotion-card
export type PromotionCard = z.output<typeof PromotionCardSchema>;
export const PromotionCardSchema = z.object({
  title: z.string(),
  message: z.string(),
  arg1: z.string(),
  arg2: z.string(),
  cta: z.string(),

});

//retailer-service-client-hero
export type RetailerServiceClientHero = z.output<typeof RetailerServiceClientHeroSchema>;
export const RetailerServiceClientHeroSchema = z.object({
  title: z.string(),
  content: z.string(),
  byPhone: z.string(),
  byEmail: z.string(),
});

//satisfaction-card
export type SatisfactionCard = z.output<typeof SatisfactionCardSchema>;
export const SatisfactionCardSchema = z.object({
  label: z.string(),
  content: z.string(),
});

//retailer-customer-slide
export type RetailerCustomerSlide = z.output<typeof RetailerCustomerSlideSchema>;
export const RetailerCustomerSlideSchema = z.object({
  name: z.string(),
  url: z.string(),
  logo: ImageTs

  // slides: ImageTs.array().nullable()
});

//retailer-customer-card
export type RetailerCustomerCard = z.output<typeof RetailerCustomerCardSchema>;
export const RetailerCustomerCardSchema = z.object({
  title: z.string(),
  slides: RetailerCustomerSlideSchema.array()
  // slides: ImageTs.array().nullable()
});

//traveler-card
export type TravelerCard = z.output<typeof TravelerCardSchema>;
export const TravelerCardSchema = z.object({
  title: z.string(),
  content: z.string(),
  knowMoreCTA: z.string(),
  downloadCta: z.string(),
  picture: ImageTs
  //image
});


export type RetailerComponent = TravelerCard |
  RetailerCustomerCard |
  SatisfactionCard |
  RetailerServiceClientHero |
  PromotionCard |
  Hero |
  EngaginCard |
  AdvantageCard |
  RetailerCustomerSlide
